import { render } from "./PrDebugConsole.vue?vue&type=template&id=4f071ba6&scoped=true"
import script from "./PrDebugConsole.vue?vue&type=script&lang=js"
export * from "./PrDebugConsole.vue?vue&type=script&lang=js"

import "./PrDebugConsole.vue?vue&type=style&index=0&id=4f071ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f071ba6"]])

export default __exports__